export default "__VITE_ASSET__Djuhkcbn__"